import styled from 'styled-components';

import { IBasicTestProps } from '@styles/model';

import { ETextDecoration } from './model';

interface ITextButton {
  textDecoration: string;
  hasHover?: boolean;
  disabled: boolean;
}

const setHover = (textDecoration: string, hasHover: boolean) => {
  if (!hasHover) {
    return textDecoration;
  }

  switch (textDecoration) {
    case ETextDecoration.NONE.toString():
      return ETextDecoration.UNDERLINE;
    case ETextDecoration.UNDERLINE.toString():
      return ETextDecoration.NONE;
    default:
      throw new Error('Text button property text decoration is invalid.');
  }
};

export const TextButtonStyled = styled.a.attrs<IBasicTestProps>(({ dataTestId }) => ({
  className: dataTestId,
}))<ITextButton>`
  text-decoration: ${({ textDecoration }) => textDecoration};
  font-weight: 300;
  font-size: 0.875rem;
  line-height: 1.875rem;
  cursor: pointer;
  &:hover {
    text-decoration: ${({ textDecoration, hasHover }) => setHover(textDecoration, hasHover!)};
  }
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;
